import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';
import { BASE_KEY } from './customerAvatarsKeys';

export interface IUpsertCustomerAvatarParams {
  avatarId: string;
  avatarName: string;
  description: string;
  title: string;
  default: number;
}

interface IUpsertCustomerAvatarResponse {
  avatarId: string;
  customerId: number;
  avatarName: string;
  description: string;
  title: string;
  default: number;
}

export const updateCustomerAvatar = async (
  params: IUpsertCustomerAvatarParams
): Promise<IUpsertCustomerAvatarResponse> => {
  const { avatarId, ...rest } = params;
  const response = await EXPRESS_API.put(`/customer-avatars/${avatarId}`, rest);
  return response.data;
};

export const useEditCustomerAvatarMutation = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  return useMutation(updateCustomerAvatar, {
    onSuccess: async () => {
      await queryClient.refetchQueries({
        queryKey: BASE_KEY,
        exact: false,
      });
      onSuccess && onSuccess();
      successToast({
        title: `Customer's avatar has been successfully updated!`,
      });
    },
    onError: error =>
      showError(
        error ||
          `An error occurred while trying to update the customer's avatar!`
      ),
  });
};
